import { useSEO } from "@/hooks/useSEO";
import { ComingSoon } from "@/components/ComingSoon";
import { useLanguage } from "@/context/LanguageContext";

export default function Actors() {
  const { t } = useLanguage();
  useSEO(
    t("nav.actors") + " — Diamotims Agency",
    "Film, television, theatre and commercial actors — division opening soon at Diamotims Agency, Montréal."
  );
  return <ComingSoon eyebrow={t("actors.eyebrow")} pageTestid="actors-page" />;
}
